import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class StepRouterService {
  constructor(private router: Router) {}

  goToRoot() {
    this.router.navigate(['/'], { queryParamsHandling: 'preserve' });
  }

  goToStep(step: string) {
    if (!step.startsWith('/')) {
      step = '/' + step;
    }
    this.router.navigate([this.router.url.replace(/\/([^/]+\/?)$/, step)], { queryParamsHandling: 'preserve' });
  }
}
